import { render } from "./SimpleSearch.vue?vue&type=template&id=9b8e44b6"
import script from "./SimpleSearch.vue?vue&type=script&lang=js"
export * from "./SimpleSearch.vue?vue&type=script&lang=js"

import "./SimpleSearch.vue?vue&type=style&index=0&id=9b8e44b6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__